/**
 * One-listing-per-account limit (v1, Piotr 2026-07-14). The real guard is the
 * DB trigger flat.enforce_owner_listing_limit (migration 20260714182101) —
 * this module is the client-side contract for recognising it and the shared
 * "multi-listing coming soon" messaging. Drop the trigger when multi-listing
 * ships; these paths then simply never fire.
 */

export const LISTING_LIMIT_SIGNATURE = 'owner_listing_limit';

/** Matches the trigger's raise exception message anywhere in an error string —
 * PostgREST/Supabase wrap it differently per path (client insert vs RPC). */
export function isListingLimitError(message?: string | null): boolean {
  return typeof message === 'string' && message.includes(LISTING_LIMIT_SIGNATURE);
}
